$(document).on('click','.show-more',function(event){ 
  var thisitem =  $(this).parents('.product-block');
  thisitem.addClass('shown-full');
}); 
$(document).on('click','.hide-more',function(event){ 
  var thisitem =  $(this).parents('.product-block');
  if($(window).width() >= 720 ){
    $('html, body').animate({ scrollTop: $(".desktopTab1").offset().top -225 }, 1200);
  }
  else{
    $('html, body').animate({ scrollTop: $(".Mobile1").offset().top -180 }, 1200);
  }
  setTimeout(function(){ thisitem.removeClass('shown-full'); },1500);
}); 

if($('.stamped-badge-caption').data('reviews') < '100'){
  $('.stamped-main-badge').hide();
  $('.stamped-main-badge').remove();
}
$('.desktopTab1 .collapsible-tab .collapsible-tab__heading , .Mobile1.collapsible-tab .collapsible-tab__heading').trigger('click');

$(window).scroll(function() {
  var targetDiv = $('body');
  var windowpos = $(window).scrollTop();
  var custom_mobile_scroll = $('.custom_mobile_scroll').offset();
  if(typeof(custom_mobile_scroll) != 'undefined'){
  var Final = custom_mobile_scroll.top;
  
  if( windowpos >= Final ) {
    targetDiv.addClass('mobileAtcFixed');
  } else {
    targetDiv.removeClass('mobileAtcFixed');
  }
  }
});

$(document).ready(function(){
  if($(window).width() >= 768) {
    $('.main-Gipklaviyo.mobile_main-Gipklaviyo').remove();
    $('.mobile-main-hook').remove();
  }   
  else{
    $('.main-Gipklaviyo.desktop_main-Gipklaviyo').remove();
    $('.dektop-main-hook').remove();
  }
  $('.afterpay-paragraph span.afterpay-text1').html($('.afterpay-paragraph span.afterpay-text1').text().replace("or make", "Make"));


  var interval = null;
  interval = setInterval(stampedReviews,1000);
  function stampedReviews(){
    if ($("div#stamped-reviews-tab .stamped-review").length >= 1){
      $('.stamped-review-vote .stamped-rating-holder').each(function(){
        var gethtml = $(this).html();
        var result = gethtml.includes("Was this helpful?");
      
        if (result){
          var getFinal = gethtml.replace("this h", "This Review H");
          $(this).html(getFinal);
        }
        else{
         
        }
      });

      clearInterval(interval);
    }
  }
});


$(document).on('click','.getPackInfo',function(event){ 
  $('body').addClass('activeklaviyo');
}); 

$(document).on('click','.closeKlaviyo , .overlayklaviyo',function(event){ 
  $('body').removeClass('activeklaviyo');
}); 

$(document).on('click','button.needsclick.kl-private-reset-css-Xuajs1',function(event){ 
  var this_p =$(this).parents('.klaviyoForm');
  var klaviyoForminterval = null;
  klaviyoForminterval = setInterval(klaviyoForm,1000);
  function klaviyoForm(){
    if(!$('button.needsclick.kl-private-reset-css-Xuajs1').is(":visible")){
      if(this_p.find('form input[type="submit"]').is(":visible")){
       
      }
      else{
        clearInterval(klaviyoForminterval);
        setTimeout(function(){
          //location.reload();
        },3000);

      }
    } 
  }
}); 


$(document).ready(function(){



  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  var cart_currency = getCookie("cart_currency");
  if (cart_currency != "") {
    if (cart_currency == 'AUD' ){
      $('.footer-addresses').addClass('aud');
    }
    if (cart_currency == 'USD' ){
      $('.footer-addresses').addClass('usd');
    }

    if (cart_currency == 'USD' || cart_currency == 'AUD' || cart_currency == 'NZD' ){
      $('.product--outer .product-main').addClass('showAfterpay');
    }
    else{
      $('.site-footer-right').addClass('hideAmazonPay');
    }

    var SetNewCurrecny= getCookie('SetNewCurrecny');
    if(SetNewCurrecny){
    }
    else{
      jQuery.getJSON('https://ipapi.co/json', function(location) {

        function setCookie(key, value, expiry) {
          var expires = new Date();
          expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
          document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
        }

        if(location.country){
          var mycountry = location.country_name;
          var mycurrency = location.currency;
          var mycountry_code = location.country_code;

          var current_cookie_value= getCookie('cart_currency');
          if (mycurrency == current_cookie_value){
            setCookie('SetNewCurrecny', mycurrency,'1');
          }
          else{
            $('.disclosure .disclosure-list li .disclosure-list__option').each(function(){
              var val= $(this).text();
              if (val){
                var trimVal =val.trim();
                if (trimVal == mycountry ){
                  $(this).parents('.disclosure-list__item').find('span').trigger('click');
                }
              }
            });

          }
        }
      });
    }


    $(document).on('click','.template-collection .disclosure__toggle',function(){
      if ($(this).attr('aria-expanded') == "false" ){
        $(this).attr('aria-expanded','true');
        $(this).parents('form').find('.disclosure-list').addClass('disclosure-list--visible');
      }
      else{
        $(this).attr('aria-expanded','false');
        $(this).parents('form').find('.disclosure-list').removeClass('disclosure-list--visible');
      }
    });

  }
  
  /*$(".lazyload").lazyload();*/

});


 $("#infopackform").submit(function(e){
    e.preventDefault();
    var action = $(this).attr("action");
    $.ajax({
    type: "POST",
    url: action,
    crossDomain: true,
    data: new FormData(this),
    dataType: "json",
    processData: false,
    contentType: false,
    headers: {
      "Accept": "application/json"
    }
  }).done(function() {
     $('.success').addClass('is-active');
  }).fail(function() {
     alert('An error occurred! Please try again later.')
  });
});